export default (state = {}, action) => {
  switch (action.type) {
    case 'SYSTEMDETAIL':
      return Object.assign({}, action.payload);
    default:
      return state;
  }
};
